import { getEndpointPlugin } from "@smithy/middleware-endpoint";
import { getSerdePlugin } from "@smithy/middleware-serde";
import { Command as $Command } from "@smithy/smithy-client";
import { commonParams } from "../endpoint/EndpointParameters";
import { de_CreateAdapterCommand, se_CreateAdapterCommand } from "../protocols/Aws_json1_1";
export { $Command };
export class CreateAdapterCommand extends $Command
    .classBuilder()
    .ep(commonParams)
    .m(function (Command, cs, config, o) {
    return [
        getSerdePlugin(config, this.serialize, this.deserialize),
        getEndpointPlugin(config, Command.getEndpointParameterInstructions()),
    ];
})
    .s("Textract", "CreateAdapter", {})
    .n("TextractClient", "CreateAdapterCommand")
    .f(void 0, void 0)
    .ser(se_CreateAdapterCommand)
    .de(de_CreateAdapterCommand)
    .build() {
}
